import type { ComponentPropsWithRef } from "react";

import { cn } from "../lib/cn";

/**
 * Touche de clavier. À utiliser dans la documentation et les menus pour
 * afficher un raccourci : `<Kbd>⌘</Kbd><Kbd>K</Kbd>`.
 */
export function Kbd({ className, ...props }: ComponentPropsWithRef<"kbd">) {
  return (
    <kbd
      className={cn(
        "inline-flex h-5 min-w-5 items-center justify-center rounded-sm px-1.5",
        "border border-border border-b-2 bg-surface-raised shadow-xs inset-shadow-raised",
        "font-mono text-[11px] font-medium text-fg-muted",
        className,
      )}
      {...props}
    />
  );
}
